import { action } from 'easy-peasy';
import { IActionSetClientCrisisAllocations } from '../types';

const setClientCrisisAllocations: IActionSetClientCrisisAllocations = action((state, payload) => {
  const { items, pagination, filters } = payload;

  if (pagination) {
    state.crisisPagination.pageNumber = pagination.pageNumber;
    state.crisisPagination.pageSize = pagination.pageSize;
    state.crisisPagination.total = pagination.total;
  }

  if (filters) {
    state.crisisFilters = filters;
  }
  state.crisisList = items;
});

export default setClientCrisisAllocations;
